import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root',
})
export class ReferenceService {
  private baseApiUrl: string = environment.API_BASE_URL;

  constructor(private readonly http: HttpClient) {}

  getCountries(): Observable<any[]> {
    return this.http.get<any[]>(`${this.baseApiUrl}/reference/countries`);
  }

  getIndustries(): Observable<any[]> {
    return this.http.get<any[]>(`${this.baseApiUrl}/reference/industries`);
  }
}
